import { defineComponent, ref, markRaw, computed, onMounted, nextTick, onUnmounted, openBlock, createBlock, Teleport, createVNode, Transition, withCtx, createElementBlock, withKeys, createElementVNode, normalizeClass, unref, createCommentVNode, resolveDynamicComponent, mergeProps } from "vue";
import { CdrButton, IconXLg, IconArrowLeft, IconArrowRight } from "@rei/cedar";
import UgcImageViewer from "../UgcImageViewer/UgcImageViewer.mjs";
import ImageZoom from "../ImageZoom/ImageZoom.mjs";
import GenericMedia from "../GenericMedia/GenericMedia.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ImageViewer",
  props: {
    ugcImageViewerProps: {
      default: null
    },
    imageZoomProps: {
      default: null
    },
    mediaType: {},
    videoProps: {
      default: null
    },
    showArrows: {
      type: Boolean,
      default: true
    }
  },
  emits: ["imageZoomClose", "nextImage", "prevImage", "ugcImageViewerSelect", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const imageViewerContainer = ref();
    const imageViewer = ref();
    const begin = ref();
    const end = ref();
    const closeRef = ref();
    const leftArrow = ref();
    const rightArrow = ref(null);
    const offset = ref();
    const componentMap = ref({
      video: markRaw(GenericMedia),
      image: markRaw(ImageZoom),
      ugc: markRaw(UgcImageViewer)
    });
    const props = __props;
    const emit = __emit;
    const viewerComponent = computed(() => componentMap.value[props.mediaType]);
    const viewerComponentProps = computed(() => {
      const componentPropsMap = {
        video: props.videoProps,
        image: props.imageZoomProps,
        ugc: props.ugcImageViewerProps
      };
      return componentPropsMap[props.mediaType];
    });
    const computedComponentClass = computed(() => {
      if (props.mediaType === "video") return "image-viewer__video";
      if (props.mediaType === "ugc") return "image-viewer__ugc";
      return null;
    });
    onMounted(async () => {
      var _a, _b, _c, _d, _e, _f, _g;
      await nextTick();
      (_a = imageViewer.value) == null ? void 0 : _a.focus();
      offset.value = window.scrollY;
      (_d = (_c = (_b = window == null ? void 0 : window.document) == null ? void 0 : _b.body) == null ? void 0 : _c.classList) == null ? void 0 : _d.add("image-viewer-background--no-scroll");
      (_g = (_f = (_e = window == null ? void 0 : window.document) == null ? void 0 : _e.documentElement) == null ? void 0 : _f.classList) == null ? void 0 : _g.add("image-viewer-background--no-scroll");
    });
    onUnmounted(() => {
      var _a, _b, _c, _d, _e, _f, _g;
      (_c = (_b = (_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement) == null ? void 0 : _b.classList) == null ? void 0 : _c.remove("image-viewer-background--no-scroll");
      (_f = (_e = (_d = window == null ? void 0 : window.document) == null ? void 0 : _d.body) == null ? void 0 : _e.classList) == null ? void 0 : _f.remove("image-viewer-background--no-scroll");
      if (offset.value) (_g = window == null ? void 0 : window.scrollTo) == null ? void 0 : _g.call(window, 0, offset.value);
    });
    function close() {
      emit("imageZoomClose");
    }
    function handleFocus(e) {
      if (imageViewer.value && !imageViewer.value.contains(e.target)) {
        const focusables = getFocusables();
        const firstFocusable = focusables[0];
        const lastFocusable = focusables[focusables.length - 1];
        const isLeavingFirstElement = firstFocusable === e.relatedTarget;
        const elToFocusOn = isLeavingFirstElement ? lastFocusable : firstFocusable;
        if (elToFocusOn instanceof HTMLElement) elToFocusOn.focus();
      }
    }
    function getFocusables() {
      return imageViewerContainer.value ? [...imageViewerContainer.value.querySelectorAll("button")].filter((el) => !el.hasAttribute("disabled")) : [];
    }
    function clickLeft() {
      emit("prevImage");
    }
    function clickRight() {
      emit("nextImage");
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, {
        to: "body"
      }, [createVNode(Transition, {
        name: "image-zoom"
      }, {
        default: withCtx(() => [(openBlock(), createElementBlock("div", {
          key: 0,
          ref_key: "imageViewerContainer",
          ref: imageViewerContainer,
          class: "image-viewer",
          onFocusin: handleFocus,
          onKeydown: withKeys(close, ["esc"])
        }, [createElementVNode("div", {
          ref_key: "begin",
          ref: begin,
          tabindex: "0"
        }, null, 512), createElementVNode("div", {
          ref_key: "imageViewer",
          ref: imageViewer,
          tabindex: "-1",
          class: normalizeClass(["image-viewer__wrapper", _ctx.mediaType === "video" ? "image-viewer__wrapper--video" : null])
        }, [createVNode(unref(CdrButton), {
          ref_key: "closeRef",
          ref: closeRef,
          "aria-label": "Close",
          class: "image-viewer__button image-viewer__button--close",
          "icon-only": true,
          onClick: close
        }, {
          default: withCtx(() => [createVNode(unref(IconXLg))]),
          _: 1
        }, 512), _ctx.showArrows ? (openBlock(), createBlock(unref(CdrButton), {
          key: 0,
          ref_key: "leftArrow",
          ref: leftArrow,
          "aria-label": "Show previous image",
          class: "image-viewer__button image-viewer__button--left",
          "icon-only": true,
          "with-background": true,
          onClick: clickLeft
        }, {
          default: withCtx(() => [createVNode(unref(IconArrowLeft))]),
          _: 1
        }, 512)) : createCommentVNode("", true), _ctx.showArrows ? (openBlock(), createBlock(unref(CdrButton), {
          key: 1,
          ref_key: "rightArrow",
          ref: rightArrow,
          "aria-label": "Show next image",
          class: "image-viewer__button image-viewer__button--right",
          "icon-only": true,
          "with-background": true,
          onClick: clickRight
        }, {
          default: withCtx(() => [createVNode(unref(IconArrowRight))]),
          _: 1
        }, 512)) : createCommentVNode("", true), (openBlock(), createBlock(resolveDynamicComponent(viewerComponent.value), mergeProps(viewerComponentProps.value, {
          class: computedComponentClass.value,
          onKeydown: withKeys(close, ["esc"]),
          onUgcImageViewerSelect: _cache[0] || (_cache[0] = (data) => _ctx.$emit("ugcImageViewerSelect", data)),
          onNextImage: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("nextImage")),
          onPrevImage: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("prevImage")),
          onImageZoomClose: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("imageZoomClose")),
          onMetricsClick: _cache[4] || (_cache[4] = (data) => _ctx.$emit("metricsClick", data))
        }), null, 16, ["class"]))], 2), createElementVNode("div", {
          ref_key: "end",
          ref: end,
          tabindex: "0"
        }, null, 512)], 544))]),
        _: 1
      })]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ImageViewer2.mjs.map
